import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['framework-agreement-supplier-files'],
  queryOptions: {},
};

const getFrameworkAgreementSupplierFiles = async (faId, facId, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/framework_agreements/${faId}/suppliers/${facId}/files?${queryString}`);

  return { files: data || [], total };
};

export const useFrameworkAgreementsSupplierFiles = (faId, facId, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, facId], () => getFrameworkAgreementSupplierFiles(faId, facId, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};